import usePartner from '../usePartner'
import { useFeature } from '@pcln/feature-components'

function useHeaderPhoneNumber () {
  const configPhoneNumber = usePartner('config.header.phoneNumber')
  const dynamicPhoneNumber = useFeature('whiteLabel.dynamicHeaderPhoneNumber')

  return dynamicPhoneNumber || configPhoneNumber
}

export default useHeaderPhoneNumber
